export const URL_BASE='https://d1jfep5grqw6yf.cloudfront.net/'

// 承認ステータス
export const APPROVAL_STATUS = {
    UNAPPROVED: "3",
    APPROVED: "2",
    REMAND: "1",
    INIT: "0",
};
// 権限
export const ROLE_UUID = {
    ADMIN: '0282b4ca-723d-0c9b-4e77-fef6085886c8',
    APPROVER: 'cd6613ed-dc0b-fc64-062f-fad01c6cab66',
    REQUESTER: 'ae897611-bf7d-763d-a504-b7d3ac357f2b',
    VIEWER: '575fb7fd-022f-b127-d895-f7b5165b1add',
};

// 報告ステータス
export const REPORT_STATUS = {
    UNSUPPORTED: '353ae745-58fe-1832-5d57-d1266957596b',
    FISRTREPORT: '190dcbb8-2191-d1f6-3bdb-124d46294140',
    PRIMARYCHECK: 'b98717f8-08c4-d3d9-b196-c0bb6b41a612',
    SECONDARYCHECK: '89cf4cdf-1d0d-9b71-706b-e705866c8fd8',
    REPORTSTOP: '60232b42-0aed-54ce-f30e-f4e0f5c77da9',
    POWERPLANTSUPPORT: 'da13256b-c8fa-483b-8e4e-027e8800313c',
    POWERPLANTCOMPLETE: '95157771-ae56-48f1-afb6-fe7e41b2366d',
}

// 時刻
export const REPORTING_TIME = {
    INITIALTASK: 20,
    FISRTREPORT: 60,
    PRIMARYCHECK: 150,
    SECONDARYCHECK: 1380
}

// 取水停止発電所及び水路抜水発電所を決定
export const SELECTED_DRAINAGE_POWERPLANT = {
    INTAKESTOP: '3f2c6e6a-8f3d-4a2f-9b2e-1f5c9a7d4c01', // 取水停止
    DRAINAGE: '7a9d4b21-5e6c-4d18-9c74-b8f2a3e6d902', // 水路抜水
    CONTINUE: 'c1e8f9d4-2b6a-4f3e-8a57-6d0b9c21a503' // 運転継続
}

export const DASHBOARD_URL = 'https://edison.jp10.analytics.cloud.sap/sap/fpa/ui/app.html#/story2?shellMode=embed&/s2/DFBBCB33E1E98E645F3F290FD209A9E3/?pageBar=disable&isOVM=true&mode=embed'

export const ENVIRONMENT_LABEL = ''